var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.pconUrl !== ""
      ? _c("div", { staticClass: "single__intro-wrapper position-relative" }, [
          _c("iframe", {
            ref: "iframe",
            staticStyle: { width: "100%", height: "80vh" },
            attrs: { src: _vm.pconUrl, frameborder: "0" },
            on: { load: _vm.onIframeLoad }
          }),
          _vm._v(" "),
          _vm.isProcessing
            ? _c("div", { staticClass: "pcon-loader__wrapper" }, [
                _c("div", { staticClass: "pcon-loader__content" }, [
                  _c("div", {
                    staticClass: "text",
                    domProps: { innerHTML: _vm._s(_vm.text) }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "loader" })
                ])
              ])
            : _vm._e()
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }